/// <amd-module name="Wit/UI/Card/WorkItemCardContent" />
export * from "./Components/WorkItemCardContent/WorkItemCardContent";
export { IWorkItemCardCoreFieldsProps } from "./Components/WorkItemCardContent/WorkItemCardContent.Props";
